import { httpService } from '@/services/api';

export const list = async () => {
  const { data } = await httpService.get(`/workspaces`);

  return data
}


export const detail = async (id) => {
  const { data } = await httpService.get(`/workspaces/${id}`);

  return data
}


export const create = async (payload) => {
  const { data } = await httpService.post('/workspaces', {
    ...payload
  });
  return data
}

export const update = async (payload) => {
  try {

  const { data } = await httpService.put('/workspaces', {
    ...payload
  });
  return data 
  } catch (error) {
    console.error('Error updating workspace:', error);
  }
}

export const changeCurrentWorkspace = async (id, info, callback) => {
  localStorage.setItem(process.env.REACT_APP_CURRENT_WORKSPACE, id)
  localStorage.setItem(process.env.REACT_APP_CURRENT_WORKSPACE_INFO, JSON.stringify(info))
  callback && callback()
}

export const getCurrentWorkspace = () => {
  return localStorage.getItem(process.env.REACT_APP_CURRENT_WORKSPACE)
}

export const getCurrentWorkspaceInfo = () => {
  const currentWorkspace = localStorage.getItem(process.env.REACT_APP_CURRENT_WORKSPACE_INFO)
  if (!currentWorkspace || currentWorkspace === 'undefined') {
    return null
  }

  return JSON.parse(currentWorkspace)
}
